import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    data: {
      seo: {
        title: 'Centelha — Reflexões e meditações diárias pra alimentar sua fé',
        description:
          'Cultive sua espiritualidade no dia a dia com reflexões guiadas, meditações diárias e um espaço pra dialogar com sua fé. Comece agora.',
        canonicalPath: '/',
        appendAppName: false,
      },
    },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/signup/signup.page').then(m => m.SignupPage),
    data: {
      seo: {
        title: 'Criar conta',
        description: 'Crie sua conta Centelha gratuitamente e comece sua jornada de reflexão espiritual.',
        canonicalPath: '/signup',
        robots: 'noindex, follow',
      },
    },
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    data: {
      seo: {
        title: 'Entrar',
        description: 'Acesse sua conta Centelha pra continuar suas reflexões e meditações.',
        canonicalPath: '/login',
        robots: 'noindex, follow',
      },
    },
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/login/reset-password/reset-password.page').then(m => m.ResetPasswordPage),
    data: {
      seo: {
        title: 'Recuperar senha',
        description: 'Recupere o acesso à sua conta Centelha.',
        robots: 'noindex, nofollow',
      },
    },
  },
  {
    path: 'my-account',
    loadChildren: () => import('./pages/my-account/my-account.routes').then(m => m.MY_ACCOUNT_ROUTES),
  },
  {
    path: 'notifications',
    loadComponent: () => import('./pages/notifications/notifications.page').then(m => m.NotificationsPage),
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    data: {
      seo: {
        title: 'Centelha — Reflexões e meditações diárias pra alimentar sua fé',
        description:
          'Cultive sua espiritualidade no dia a dia com reflexões guiadas, meditações diárias e um espaço pra dialogar com sua fé. Comece agora.',
        canonicalPath: '/',
        appendAppName: false,
        jsonLd: {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Centelha — Reflexões e meditações diárias',
          description:
            'Cultive sua espiritualidade no dia a dia com reflexões guiadas, meditações diárias e um espaço pra dialogar com sua fé.',
          inLanguage: 'pt-BR',
          isPartOf: {
            '@type': 'WebSite',
            name: 'Centelha',
            url: 'https://centelha.app.br/',
          },
          publisher: {
            '@type': 'Organization',
            name: 'Centelha',
            url: 'https://centelha.app.br/',
          },
        },
      },
    },
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.page').then(m => m.OnboardingPage),
    data: {
      seo: {
        title: 'Onboarding',
        description: 'Personalize sua experiência Centelha antes de começar.',
        canonicalPath: '/onboarding',
        robots: 'noindex, nofollow',
      },
    },
  },
  {
    path: 'termos',
    loadComponent: () => import('./pages/legal/terms/terms.page').then(m => m.LegalTermsPage),
    data: {
      seo: {
        title: 'Termos de Uso',
        description: 'Termos de Uso da plataforma Centelha — direitos, deveres e regras de uso do serviço.',
        canonicalPath: '/termos',
      },
    },
  },
  {
    path: 'privacidade',
    loadComponent: () => import('./pages/legal/privacy/privacy.page').then(m => m.LegalPrivacyPage),
    data: {
      seo: {
        title: 'Política de Privacidade',
        description: 'Política de Privacidade da Centelha — como coletamos, usamos e protegemos seus dados.',
        canonicalPath: '/privacidade',
      },
    },
  },
  {
    path: 'noticias',
    loadComponent: () => import('./pages/news/news-list/news-list.page').then(m => m.NewsListPage),
    data: {
      seo: {
        title: 'Reflexões e meditações',
        description:
          'Reflexões espirituais, meditações diárias e novidades do Centelha. Conteúdo pra alimentar sua fé no dia a dia.',
        canonicalPath: '/noticias',
      },
    },
  },
  {
    path: 'noticias/:slug',
    loadComponent: () => import('./pages/news/news-detail/news-detail.page').then(m => m.NewsDetailPage),
  },
  {
    path: 'sobre',
    loadComponent: () => import('./pages/about/about.page').then(m => m.AboutPage),
    data: {
      seo: {
        title: 'Sobre',
        description:
          'Conheça o Centelha — um espaço plural de reflexão espiritual, meditações diárias e diálogo com a fé. Independente, sem vender seus dados.',
        canonicalPath: '/sobre',
      },
    },
  },
  {
    path: 'contato',
    loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPage),
    data: {
      seo: {
        title: 'Contato',
        description:
          'Fale com o Centelha — atendimento geral, sugestões, parcerias e dúvidas sobre proteção de dados (LGPD).',
        canonicalPath: '/contato',
      },
    },
  },
];
